<i18n>
{
  "fr": {
    "form-list-title": "Modification d'un contact",
    "submit-create-label": "Créer",
    "submit-update-label": "Modifier",
    "delete-label": "Supprimer",
    "contact-title": "Contact"
  },
  "de": {
    "form-list-title": "Änderung eines Kontakts",
    "submit-create-label": "Erstellen",
    "submit-update-label": "Modifizieren",
    "delete-label": "Löschen",
    "contact-title": "Kontact"
  }
}
</i18n>

<template>
  <div>

    <Header :title="$t('contact-title')" />

    <md-content class="md-elevation-3 main-container">

      <ContactForm
        :contact="contact"
      />
      <div class="option-panel">
        <md-button class="md-raised md-primary" @click="saveContact">{{ submitLabel }}</md-button>
        <md-button class="md-raised md-accent" v-if="!isNew" @click="deleteContact">{{ $t('delete-label') }}</md-button>
      </div>

    </md-content>

    <Snackbar ref="snackbar" />

  </div>
</template>

<script>

import Contact from '@/models/default/Contact'
import ContactForm from '@/components/contact-form'
import Header from '@/components/header'
import Snackbar from '@/components/snackbar'

export default {
  name: 'DetailContact',
  components: {
    ContactForm,
    Header,
    Snackbar
  },
  data () {
    return {
      contact: new Contact(),
      isNew: typeof this.$route.params.id === 'undefined'
    }
  },
  computed: {
    submitLabel () {
      return typeof this.$route.params.id !== 'undefined' ? this.$t('submit-update-label') : this.$t('submit-create-label')
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadData().then(() => {

      }).catch(this.handleError)
    })
  },
  methods: {
    loadData () {
      return new Promise((resolve, reject) => {
        if (this.isNew) {
          resolve()
          return
        }

        Contact.get(this.$route.params.id).then((contact) => {
          this.contact = contact
          resolve()
        }).catch(reject)
      })
    },
    saveContact () {
      this.contact.save().then(() => {
        this.$router.push({
          name: 'list-contact'
        }).catch(this.handleError)
      })
    },
    deleteContact () {
      this.contact.delete().then(() => {
        this.$router.push({
          name: 'list-contact'
        })
      }).catch(this.handleError)
    },
    handleError (e) {
      this.$refs.snackbar.showError(e)
    }
  }
}
</script>

<style lang="scss">
.group-field {
  padding: 20px;
}

.md-layout-item {
  padding: 10px;
}

.map {
  width: 100%;
  height:400px;
}

.md-select-menu.md-menu-content-bottom-start.md-menu-content-small.md-menu-content.md-theme-default {
  @media(max-width: 960px) {
    left: 10px !important;
    max-width: calc(100% - 20px);
  }
  @media(min-width: 960px){
    max-width: 50%
  }
}
</style>
